import moment from "moment";

import { getSkipReason } from "../helpers";

const formatDay = (value?: string | null) =>
  value ? moment(value).format("MMM D, YYYY") : "not set";

export const formatScheduleValue = (
  field: string,
  value: string | number | null,
) => {
  if (field.endsWith("_offset")) {
    return typeof value === "number"
      ? `${value} ${value === 1 ? "day" : "days"} after employee start date`
      : "not set";
  }
  return formatDay(typeof value === "string" ? value : null);
};

export const formatReminderSchedule = (
  scheduledDate?: string | null,
  daysAfterStartDate?: number,
) => {
  if (scheduledDate) {
    return `due ${formatDay(scheduledDate)}`;
  }
  if (typeof daysAfterStartDate === "number") {
    return `${daysAfterStartDate} ${
      daysAfterStartDate === 1 ? "day" : "days"
    } after kickoff`;
  }
  return "";
};

/** A reason is a notification skip reason only when the event was skipped. */
export const getActivitySkipReason = (
  status: string | null | undefined,
  payload: unknown,
) => (status === "skipped" ? getSkipReason(payload) : null);

/**
 * "138 sent, 3 failed, 4 skipped", leaving out the zeroes. A batch with nothing to
 * count, like several people calibrated in one click, says how many people it touched.
 */
export const getBatchDetail = (batch: {
  sentCount: number;
  failedCount: number;
  skippedCount: number;
  rowCount: number;
}) =>
  [
    batch.sentCount > 0 ? `${batch.sentCount} sent` : null,
    batch.failedCount > 0 ? `${batch.failedCount} failed` : null,
    batch.skippedCount > 0 ? `${batch.skippedCount} skipped` : null,
  ]
    .filter(Boolean)
    .join(", ") || `${batch.rowCount} people`;
